import { valibotResolver } from '@hookform/resolvers/valibot';
import { array, boolean, check, date, number, object, optional, pipe, string, tuple, union } from 'valibot';

export const SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS = {
  TYPE: 'type',
  URGENCY: 'urgency',
  METRIC_TYPE: 'metricType',
  REPORTED_FAILURE: 'reportedFailure',
  FACILITIES: 'facilityIds',
  TIME_CREATED_RANGE: 'timeCreatedRange',
};

export interface IFormSiteEngagementMetricsFilters {
  type: string;
  urgency: string;
  metricType: string;
  reportedFailure: boolean;
  facilityIds: Array<number>;
  timeCreatedRange: Array<Date | undefined> | string;
}

export const schemaSiteEngagementMetricsFilters = valibotResolver(
  object({
    [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.TYPE]: string(),
    [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.URGENCY]: union([string(), number()]),
    [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.METRIC_TYPE]: string(),
    [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.REPORTED_FAILURE]: boolean(),
    [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.FACILITIES]: array(number()),
    [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.TIME_CREATED_RANGE]: pipe(
      tuple([optional(date()), optional(date())]),
      check((input) => {
        const [startDate, endDate] = input;

        if (startDate && !endDate) {
          return false;
        }

        return true;
      }),
    ),
  }),
);

export const siteEngagementMetricsFilters = {
  [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.TYPE]: 'all',
  [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.URGENCY]: 'all',
  [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.METRIC_TYPE]: 'days',
  [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.REPORTED_FAILURE]: false,
  [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.FACILITIES]: [],
  [SITE_ENGAGEMENT_METRICS_FILTERS_FIELDS.TIME_CREATED_RANGE]: [],
};
